import { render, staticRenderFns } from "./ToggleNotesButton.vue?vue&type=template&id=51831658&scoped=true"
import script from "./ToggleNotesButton.vue?vue&type=script&lang=js"
export * from "./ToggleNotesButton.vue?vue&type=script&lang=js"
import style0 from "./ToggleNotesButton.vue?vue&type=style&index=0&id=51831658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51831658",
  null
  
)

export default component.exports